import { Component, Inject, AfterViewInit } from '@angular/core';
import { NgbCalendar } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { FormBuilder } from '@angular/forms';
import { AppSettings } from '@src/core/AppSettings';
import { ActivationCustomerCreationComponent } from '@src/base-components/activation/steps/customer/activation-customer-creation';
import { IAuthService } from '@src/auth/auth.service.interface';
import { Retailer } from '@src/model/retailer';

@Component({
    selector: 'app-customer-creation-oris',
    templateUrl: './activation-customer-creation.html',
    styleUrls:['./activation-customer-creation.scss']
})

export class ActivationCustomerCreationOrisComponent extends ActivationCustomerCreationComponent {

    languagesTranslation = this.translateService.instant('LanguagesName');
    languages = [];

    constructor(@Inject('AuthService') private authService: IAuthService,
        calendar: NgbCalendar,
        translateService: TranslateService,
        fb: FormBuilder,
        appSettings: AppSettings) {
            super(calendar, translateService, fb, appSettings);
            this.languages = Object.keys(this.languagesTranslation);
        }

    setDefaultValues(): void {
        const userId = this.authService.getCurrentUserInstant().sub;
        const retailerStr = localStorage.getItem(`LastSelectedRetailer_${userId}`);
        if (retailerStr) {
            const retailer = JSON.parse(retailerStr) as Retailer;
            this.customer.isoCountry = retailer.isoCountry;
        } else {
            this.customer.isoCountry = 'CH';
        }

        const currentLanguage = localStorage.getItem('CurrentLanguage');
        if (currentLanguage) {
            this.customer.language = currentLanguage;
        } else {
            this.customer.language = 'en';
        }
}
    
    setLanguage(language: string) : string {
        return this.translateService.instant('LanguagesName.' + language);
    }
}
